/**
 * 患者模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

/* 病人基础信息 */
// 获取患者列表
export const patientList = (params) => {
    return req.get('/patient/info/list', params);
}

// 新增患者
export const patientAdd = (params) => {
    return req.post(`/patient/info/addPatient`, params);
}

// 修改患者信息
export const patientEdit = (params) => {
    return req.put('/patient/info', params);
}

// 删除患者信息
export const patientDelete = (patientIds) => {
        return req.delete(`/patient/info/${patientIds}`);
    }
    /* 病人详情 */
    // 获取患者详情
export const patientInfo = (patientId) => {
    return req.get(`/patient/info/${patientId}`);
}

// 获取患者交易详情
export const patientInfos = (patientId) => {
    return req.get(`/patient/info/vo/${patientId}`);
}

// 通过患者id添加会员黑名单
export const addBlacklist = (params) => {
    return req.post(`/user-block-list/add`,params);
}

// 通过电话号码和姓名获取患者信息
export const patientInfom = (params) => {
    return req.get('/patient/info/getPatientByPhoneName', params);
}

/* 病人标签 */
// 修改患者运营标签
export const labelEdit = (params) => {
    return req.post(`/patient/info/label`, params);
}

// 修改患者就诊科室
export const postEdit = (params) => {
    return req.post(`/patient/info/post`, params);
}

/* 病人记录 */
// 获取患者理疗记录
export const execute = (params) => {
    return req.get(`/patient/info/execute/list`, params);
}

// 获取患者收费记录
export const charge = (params) => {
    return req.get(`/patient/info/chargeRecord/list`, params);
}

// 获取患者门诊记录
export const outpatient = (params) => {
    return req.get(`/patient/info/outpatientRecord/list`, params);
}

// 获取患者预约记录
export const reservation = (params) => {
    return req.get(`/patient/info/reservationRecord/list`, params);
}
/**
 * 左中右开方患者模块新接口
 */
//门诊患者列表
export const getOutPatientListApi = (params) => {
        return req.post(`/order/info/orderPage`, params);
    }
    //快捷开方创建患者
export const quickPrescriptionApi = (params) => {
        return req.post(`/order/info/saveOrder`, params);
    }
    //获取患者详细信息
export const getPatientInfoApi = (params) => {
        return req.get(`/order/info/orderDetail`, params);
    }
    //获取待诊数量
export const getWaitOutpatientNumApi = (params) => {
        return req.post(`/order/info/waitSeeNum`, params);
    }
    //保存患者就诊信息
export const savePatientInfoApi = (params) => {
        return req.post(`/order/info/saveOrder`, params);
    }
    //查询初诊还是复诊
export const getDoctorVisitApi = (params) => {
    return req.get(`/order/info/getDoctorVisit`, params);
}

//查询病例信息
export const getCaseDiagnosis = (params) => {
        return req.get(`/caseDiagnosis/detail`, params);
    }
    //查询所有病历字段
export const getCaseFieldAllApi = (params) => {
        return req.get(`/caseField/getCaseFieldAll`, params);
    }
    //查询当前登录人病历字段
export const getCaseFieldApi = (params) => {
        return req.get(`/caseField/getCaseField`, params);
    }
    //编辑当前登录人病历字段
export const editCaseFieldApi = (params) => {
        return req.post(`/caseField/edit`, params);
    }
    //恢复病历字段默认值
export const restoreCaseFieldApi = (params) => {
    return req.post(`/caseField/restore`, params);
}
// 查询同一唯一标识的患者
export const queryIdentityId = (params) => {
    return req.get(`/patient/info/queryIdentityId`, params);
}
// 新增患者唯一标识
export const addIdentity = (params) => {
    return req.get(`/patient/info/addIdentity`, params);
}
// 查询唯一标识列表
export const queryIdentity = (params) => {
    return req.get(`/patient/info/queryIdentity`, params);
}
// 修改患者唯一标识
export const updateIdentity = (params) => {
    return req.get(`/patient/info/updateIdentity`, params);
}
// 根据患者查询会员
export const getMemberByPatientId = (params) => {
    return req.get(`/system/member/get/patientId`, params);
}

//查询患者对应医馆是否需要实名认证
export const checkPatientRealName = (params) => {
    return req.get(`/program/patient/checkPatientRealName`, params);
}